'use strict';

var MemberApp = angular.module('MemberApp');
// event definitions
MemberApp.factory('adobeAnalyticsService', function($q, userStore, dispatcher,
  scheduledOutageService, apiEndpointFactory, $window, $translate, $location, otppConstants, $cookies) {

  $window[otppConstants.analyticsKey] = {};
  $window.applicationReadyToBeTrackedEvent = null;

  let globalTrackingVO = {
    document: null,
    //member info
    memberId: null,
    memberInfo: null,
    authentication: null,
    //login status
    attemptedLogins: 0,
    loginStatus: null,

    //shared for event tracking
    pageName: null,
    channel: null,

    //global trackingVO
    storageDisabled: null,
    bam: null
  };

  function trackUserWithoutValidSession(response) {
    let returnValue = null;

    if (response && response.status === 502) {
      returnValue = response.status;
    } else {
      globalTrackingVO.memberId = null;
      globalTrackingVO.memberInfo = null;
      globalTrackingVO.loginStatus = 'non-authenticated';
    }

    return $q.reject(returnValue);
  }

  function trackingDataPreload() {
    if (!$window[otppConstants.analyticsKey]) {
      return $q.reject('tracking not allowed');
    }
    let irn = userStore.getIrn();

    let endpoint = apiEndpointFactory.new({
      endpointUrl: '/' + irn + '/trackingData',
      authRequired: true,
      allowedMethods: ['get']
    });

    if (!irn) {
      return trackUserWithoutValidSession();
    }

    return endpoint.get().then(function(response) {
      setMemberId(response.data.analyticsId);
      globalTrackingVO.loginStatus = 'fully-authenticated';
      globalTrackingVO.memberInfo = response.data.memberStatus;
    }, trackUserWithoutValidSession);
  }

  function getChannel(stateName) {

    let channels = {
      'home': 'members:welcome',
      'p.pension': 'members:pension',
      'p.pension-summary': 'members:pension_summary',
      'p.preferences': 'members:preferences',
      'p.documents.documents.general': 'members:document_centre:general',
      'p.documents.documents.tax': 'members:document_centre:tax',
      'p.documents.outstanding': 'members:document_centre:outstanding',
      'p.documents.required': 'members:document_centre:required',
      'p.documents.upload': 'members:document_centre:upload',
      'simple.memberAuthCallback': 'members:authentication',
      'memberAuthError': 'members:authentication',
      'p.termination.options': 'members:term-ops'
    };

    if (channels[stateName]) {
      return channels[stateName];
    }

    return 'members:login';
  }

  function setMemberId(memberId) {
    globalTrackingVO.memberId = memberId;
  }

  function getBamKey() {
    if ($cookies.get(otppConstants.bamKey)) {
      return globalTrackingVO.memberId;
    } else {
      return null;
    }
  }

  function setDataLayer() {
    $window[otppConstants.analyticsKey] = {
      document: globalTrackingVO.document,
      pageName: globalTrackingVO.pageName,
      pageUrl: $location.absUrl(),
      section: globalTrackingVO.channel,
      lang: $translate.use() + '_CA',
      mbrId: globalTrackingVO.memberId,
      loginStatus: globalTrackingVO.loginStatus,
      mbrInfo: globalTrackingVO.memberInfo,
      attemptedLogins: globalTrackingVO.attemptedLogins,
      storageDisabled: globalTrackingVO.storageDisabled,
      authentication: globalTrackingVO.authentication,
      bam: getBamKey(),
      irn: userStore.getIrn()
    };

    //clear the document value after the window object is set
    globalTrackingVO.document = null;
  }

  function fireAnalyticsEvent() {
    //Note
    //Adobe Analytics needs the applicationReadyToBeTrackedEvent variable to be global so that it can read it
    let applicationReadyToBeTrackedEvent = new CustomEvent(
      'application-ready-to-be-tracked', {
        detail: $window[otppConstants.analyticsKey]
      });
    document.dispatchEvent(applicationReadyToBeTrackedEvent);
    //this is needed
    $window.applicationReadyToBeTrackedEvent = applicationReadyToBeTrackedEvent;
  }

  /**
   *
   * Shorthand:
   *   track*: calls trackEvent
   *   trackStateChange: builds state object and calls analyticsTrackData
   */
  return {
    setMemberId: setMemberId,
    incrementLoginAttempts: function() {
      globalTrackingVO.attemptedLogins++;
    },
    clearLoginAttempts: function() {
      globalTrackingVO.attemptedLogins = 0;
      setDataLayer();
    },
    trackTechnicalDifficulties: function() {
      globalTrackingVO.authentication = 'technical difficulties';
      setDataLayer();
    },
    trackFailedLoginEvent: function() {
      globalTrackingVO.authentication = 'failed';
      this.incrementLoginAttempts();
      setDataLayer();
    },
    trackLockoutEvent: function() {
      globalTrackingVO.authentication = 'soft lock';
      setDataLayer();
    },
    trackSecurityLockoutEvent: function() {
      globalTrackingVO.authentication = 'hard lock';
      setDataLayer();
    },
    trackLoginEvent: function() {
      globalTrackingVO.authentication = 'success';
      this.incrementLoginAttempts();
      setDataLayer();
    },
    trackLogoutEvent: function() {
      globalTrackingVO.authentication = 'logged out';
      setDataLayer();
    },
    trackStateChange: function(pageName, channelName, storageDisabled) {
      globalTrackingVO.pageName = pageName;
      globalTrackingVO.channel = getChannel(channelName);
      if (storageDisabled) {
        globalTrackingVO.storageDisabled = storageDisabled;
      }

      trackingDataPreload().finally(function() {
        setDataLayer(storageDisabled);
        fireAnalyticsEvent();
      });
    },
    trackDocCentreUploadSuccess: function() {
      globalTrackingVO.document = 'upload success';
      setDataLayer();
    },
    trackDocCentreUploadError: function() {
      globalTrackingVO.document = 'upload error';
      setDataLayer();
    },
    logout: function() {
      this.trackLogoutEvent();
      this.clearLoginAttempts();
    }
  };
});

//DMWS-1363,alert specific adobe analytics event
function generateAdobeAlertReportEvent(adobeAlertAction,alertCount,alertKey){
  if(alertCount>1){
    _satellite.track('alertEvent', {'action': adobeAlertAction, 'label': 'multipleAlerts'});
  }
  else if(alertCount==1){
    _satellite.track('alertEvent', {'action': adobeAlertAction, 'label': alertKey});
  }
  
}

//DMWS-1879 Implement internal campaign tracking on Alerts
//returns the link for an alert needed to track user's behavior after clicking
function internalCampaignTrackingLink(url, pageName) {
  if (url.includes('?')) {
    return url + '&intcmp=ms:alert:we:' + pageName + ':lk';
  } else {
    return url + '?intcmp=ms:alert:we:' + pageName + ':lk';
  }
}